import { HttpApiEndpoint, HttpApiGroup, OpenApi } from "@effect/platform";
import { Authn } from "../authn";
import { Statistics } from "../../../schema/models";
export default HttpApiGroup.make("chartsv1").annotate(OpenApi.Title, "Charts V1").add(HttpApiEndpoint.get("getStatisticsConfig")`/statistics/config`.addSuccess(Statistics.StatisticsFilterConfig).annotate(OpenApi.Summary, "Get Statistics Config")).prefix("/v1/charts").middleware(Authn);
